<template>
  <div class="home-container">
    <div class="home-content">
      <div class="header">
        <div class="title">基本数据概括</div>
        <div class="head">
          <div class="left">
            <div class="summarize">
              <div class="li">
                <div class="label">小区数量</div>
                <div class="value">
                  {{ detail.generalDetail.villageCount }} <span>个</span>
                </div>
              </div>
              <div class="li">
                <div class="label">占地面积</div>
                <div class="value">
                  {{ detail.generalDetail.totalArea }} <span>㎡</span>
                </div>
              </div>
              <div class="li">
                <div class="label">建筑面积</div>
                <div class="value">
                  {{ detail.generalDetail.buildArea }} <span>㎡</span>
                </div>
              </div>
              <div class="li">
                <div class="label">户数</div>
                <div class="value">
                  {{ detail.generalDetail.householdCount }} <span>户</span>
                </div>
              </div>
              <div class="li">
                <div class="label">小区居民数量</div>
                <div class="value">
                  {{ detail.generalDetail.residentCount }} <span>个</span>
                </div>
              </div>
              <!-- <div class="li">
                <div class="label">机关业主户数</div>
                <div class="value">4500</div>
              </div> -->
            </div>
            <div class="device">
              <div class="li" v-for="(item, ind) in detail.device" :key="ind">
                <div class="label">{{ item.name }}</div>
                <div class="value">{{ item.num }} <span>个</span></div>
              </div>
            </div>
          </div>
          <div class="right">
            <div ref="myChart" class="myChart"></div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="typeList">
          <div class="title">收费情况</div>
          <div class="cont">
            <div class="li">
              <div class="label">今日收缴</div>
              <div class="value">
                {{ detail.billCensus.dayPrice }} <span>元</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本月收缴</div>
              <div class="value">
                {{ detail.billCensus.monthPrice }} <span>元</span>
              </div>
            </div>
            <div class="li">
              <div class="label">全年收缴</div>
              <div class="value">
                {{ detail.billCensus.yearPrice }} <span>元</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本年收缴率</div>
              <div class="value">
                {{
                  detail.billCensus.yearRate ? detail.billCensus.yearRate : 0
                }}
                <span>%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="typeList typeLists">
          <div class="title">设备巡检</div>
          <div class="cont">
            <div class="li">
              <div class="label">今日巡检</div>
              <div class="value">
                {{ detail.deviceData.dayCount }} <span>次</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本月巡检</div>
              <div class="value">
                {{ detail.deviceData.monthCount }} <span>次</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本年巡检</div>
              <div class="value">
                {{ detail.deviceData.yearCount }} <span>次</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="typeList">
          <div class="title">巡更情况</div>
          <div class="cont">
            <div class="li">
              <div class="label">今日巡更完成率</div>
              <div class="value">
                {{ detail.patrol.dayRate }} <span>%</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本月巡更完成率</div>
              <div class="value">
                {{ detail.patrol.monthRate }} <span>%</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本年巡更完成率</div>
              <div class="value">
                {{ detail.patrol.yearRate }} <span>%</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="footer">
        <div class="title">工单情况</div>
        <div class="foot">
          <div class="left">
            <div class="statistics">
              <div class="li">
                <div class="label">今日上报工单数</div>
                <div class="value">{{ detail.orderWork.dayAddCount }}</div>
              </div>
              <div class="li">
                <div class="label">今日完成工单数</div>
                <div class="value">{{ detail.orderWork.daySuccessCount }}</div>
              </div>
              <div class="li">
                <div class="label">待完成工单数</div>
                <div class="value">{{ detail.orderWork.waitCount }}</div>
              </div>
              <div class="li">
                <div class="label">本月完成工单数</div>
                <div class="value">{{ detail.orderWork.waitCount }}</div>
              </div>
              <div class="li">
                <div class="label">本年完成工单数</div>
                <div class="value">{{ detail.orderWork.yearSuccessCount }}</div>
              </div>
            </div>
            <div class="orderList">
              <img class="notice" src="../assets/imgs/notice.png" alt="" />
              <div class="scroll">
                <vueSeamlessScroll
                  :data="vehicleRecordListData"
                  :class-option="defaultOption"
                >
                  <div class="list">
                    <div
                      class="li"
                      v-for="(item, ind) in vehicleRecordListData"
                      :key="ind"
                      @click="gotoOrderwork(item)"
                    >
                      <span class="nottitle">报修:{{item.villageName}} - {{ item.des }}</span>
                      <span>上报时间:{{ item.createTime }}</span>
                      <span>状态:{{ funStatus(item.status) }}</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </vueSeamlessScroll>
              </div>
            </div>
          </div>
          <div class="right">
            <div ref="myChart1" class="myChart"></div>
          </div>
        </div>
      </div>
    </div>
        <!-- 新增模态框 -->
        <el-dialog
          title="详情"
          :visible.sync="isAddModal"
          width="50%"
          :close-on-click-modal="false"
        >
          <el-form
            ref="form"
            :model="addData"
            label-width="90px"
            label-position="center"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="订单编号" prop="orderWorkNo">
                  <el-input
                    v-model="addData.orderWorkNo"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报修类型" prop="orderCategoryName">
                  <el-input
                    v-model="addData.orderCategoryName"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="报修人" prop="userName">
                  <el-input
                    v-model="addData.userName"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="房屋信息" prop="houseNumber">
                  <el-input
                    v-model="addData.houseNumber"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="报修内容" prop="des">
                  <el-input
                    v-model="addData.des"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报修图片" prop="createTime">
                  <div v-if="addData.img" style="cursor: pointer" v-viewer>
                    <img
                      :src="item"
                      v-for="(item, ind) in addData.img.split(',')"
                      :key="ind"
                      alt=""
                      style="width: 100px; height: 100px"
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="受理人" prop="handleUser">
                  <el-input
                    v-model="addData.handleUser"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报修地址" prop="address">
                  <el-input
                    v-model="addData.address"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="分发时间" prop="distributeTime">
                  <el-input
                    v-model="addData.distributeTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分发人员" prop="handleUser">
                  <el-input
                    v-model="addData.handleUser"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="接收时间" prop="receiveTime">
                  <el-input
                    v-model="addData.receiveTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="接收人员" prop="handleUser">
                  <el-input
                    v-model="addData.handleUser"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="报修时间" prop="createTime">
                  <el-input
                    v-model="addData.createTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="完成时间" prop="completeTime">
                  <el-input
                    v-model="addData.completeTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="完成图片" prop="createTime">
                  <div
                    v-if="addData.completeImg"
                    style="cursor: pointer"
                    v-viewer
                  >
                    <img
                      :src="item"
                      v-for="(item, ind) in addData.completeImg.split(',')"
                      :key="ind"
                      alt=""
                      style="width: 100px; height: 100px"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="完成备注" prop="completeDesc">
                  <el-input
                    v-model="addData.completeDesc"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="评价等级" prop="evaluateScore">
                  <el-select
                    v-model="addData.evaluateScore"
                    disabled
                    clearable
                    filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评价时间" prop="evaluateTime">
                  <el-input
                    v-model="addData.evaluateTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="评价内容" prop="evaluateDesc">
                  <el-input
                    v-model="addData.evaluateDesc"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isAddModal = false">确 定</el-button>
            <!-- <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          > -->
          </span>
        </el-dialog>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  name: "home",
  data() {
    return {
      detail: {
        summarize: {
          num: "12",
          eaer: "16800平米",
        },
        device: [
          {
            id: 1,
            name: "地面停车位",
            num: 0,
          },
          {
            id: 2,
            name: "地下停车位",
            num: 0,
          },
          {
            id: 3,
            name: "电梯数量",
            num: 0,
          },
          {
            id: 4,
            name: "消防栓数量",
            num: 0,
          },
          {
            id: 5,
            name: "灭火器数量",
            num: 0,
          },
          {
            id: 6,
            name: "高配房数量",
            num: 0,
          },
          {
            id: 7,
            name: "管理人员",
            num: 0,
          },
          {
            id: 8,
            name: "客服人员",
            num: 0,
          },
          {
            id: 9,
            name: "工程人员",
            num: 0,
          },
          {
            id: 10,
            name: "秩序维护人员",
            num: 0,
          },
          {
            id: 11,
            name: "保洁绿化人员",
            num: 0,
          },
          {
            id: 12,
            name: "总人数",
            num: 0,
          },
        ],
        generalDetail: {
          villageCount: "",
          totalArea: "",
          buildArea: "",
          householdCount: "",
          residentCount: "",
        },
        deviceData: {
          dayCount: 0,
          monthCount: 0,
          yearCount: 0,
        },
        patrol: {
          dayRate: 0,
          monthRate: 0,
          yearRate: 0,
        },
        billCensus: {
          dayPrice: 0,
          monthPrice: 0,
          monthSuccessCount: 0,
          yearRate: 0,
          yearPrice: 0,
          yearReceivablePrice: 0,
        },
        orderWork: {
          dayAddCount: 0,
          daySuccessCount: 0,
          monthSuccessCount: 0,
          waitCount: 0,
          yearSuccessCount: 0,
          orderWorkList: [],
        },
        baseDetail: {},
      },
      defaultOption: {
        limitMoveNum: 5,
        singleHeight: 200,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        step: 0.5,
      },
      options: [
        {
          value: 1,
          label: "非常满意",
        },
        {
          value: 2,
          label: "满意",
        },
        {
          value: 3,
          label: "一般",
        },
        {
          value: 0,
          label: "暂无",
        },
      ],
      vehicleRecordListData: [],
      chart: null,
      chart1: null,
      isAddModal: false,
      addData: {},
    };
  },
  mounted() {
    this.devicePatrolCensus();
    this.patrolCensus();
    this.baseBillCensus();
    this.orderWorkCensus();
    this.orderWorkProportion();
    this.generalDetail();
    this.ownerSatisfyCensus();
  },
  methods: {
    gotoOrderwork(item) {
      this.addData = item;
      this.isAddModal = true;
    },
    funStatus(row) {
      if (row == 0) {
        return "待分发";
      } else if (row == 1) {
        return "待接收";
      } else if (row == 2) {
        return "进行中";
      } else if (row == 3) {
        return "已完成";
      } else if (row == 4) {
        return "已评价";
      } else if (row == 5) {
        return "已取消";
      } else if (row == 6) {
        return "已拒绝";
      }
    },
    // 概括详情
    generalDetail() {
      this.$Apis.generalDetail().then((res) => {
        if (res.code == 200) {
          this.detail.device.forEach((item) => {
            if (item.name == "地面停车位") {
              item.num = res.data.landParkingSpace;
            } else if (item.name == "地下停车位") {
              item.num = res.data.underLandParkingSpace;
            } else if (item.name == "电梯数量") {
              item.num = res.data.liftCount;
            } else if (item.name == "消防栓数量") {
              item.num = res.data.fireHydrantCount;
            } else if (item.name == "灭火器数量") {
              item.num = res.data.annihilatorCount;
            } else if (item.name == "高配房数量") {
              item.num = res.data.heightWingCount;
            } else if (item.name == "管理人员") {
              item.num = res.data.manageStaff;
            } else if (item.name == "客服人员") {
              item.num = res.data.customerServiceStaff;
            } else if (item.name == "工程人员") {
              item.num = res.data.projectStaff;
            } else if (item.name == "保洁绿化人员") {
              item.num = res.data.cleaningStaff;
            } else if (item.name == "秩序维护人员") {
              item.num = res.data.maintenanceStaff;
            } else if (item.name == "总人数") {
              item.num = res.data.userCount;
            }
          });
          this.detail.generalDetail = res.data;
        }
      });
    },
    // 设备巡检
    devicePatrolCensus() {
      this.$Apis.devicePatrolCensus({ type: -1 }).then((res) => {
        if (res.code == 200) {
          this.detail.deviceData = res.data;
        }
      });
    },
    // 巡更
    patrolCensus() {
      this.$Apis.patrolCensus({ type: -1 }).then((res) => {
        if (res.code == 200) {
          this.detail.patrol = res.data;
        }
      });
    },
    // 缴费统计
    baseBillCensus() {
      this.$Apis.baseBillCensus({ type: -1 }).then((res) => {
        if (res.code == 200) {
          this.detail.billCensus = res.data;
          if (res.data.yearReceivablePrice) {
            this.detail.billCensus.yearRate = (
              (this.detail.billCensus.yearPrice /
                res.data.yearReceivablePrice) *
              100
            ).toFixed(2);
          }
        }
      });
    },
    // 工单情况
    orderWorkCensus() {
      this.$Apis.orderWorkCensus({ type: -1 }).then((res) => {
        if (res.code == 200) {
          this.detail.orderWork = res.data;
          this.vehicleRecordListData = res.data.orderWorkList;
        }
      });
    },
    // 工单情况占比图
    orderWorkProportion() {
      this.$Apis.orderWorkProportion({ type: -1 }).then((res) => {
        if (res.code == 200) {
          this.initOptions1(res.data);
        }
      });
    },
    // 业主满意率
    ownerSatisfyCensus() {
      this.$Apis.ownerSatisfyCensus({ type: -1 }).then((res) => {
        if (res.code == 200) {
          this.initOptions(res.data);
        }
      });
    },
    initOptions(row) {
      let nameDate = [],
        data = [];
      if (row.length > 0) {
        row.forEach((ele) => {
          nameDate.push(ele.name);
          if (!ele.ownerSatisfyCount) {
            ele.ownerSatisfyCount = 0;
          }
          data.push(ele.ownerSatisfyCount);
        });
      }
      let options = {
        title: {
          text: "业主满意率",
          // bottom: "left",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          formatter: function (param) {
            var content = "<div>";
            content += "<p>" + param[0].name + "</p>";
            content += "<p>满意率：" + param[0].data + "%" + "</p>";
            content += "</div>";
            return content;
          },
        },
        xAxis: {
          type: "category",
          data:
            nameDate.length > 0
              ? nameDate
              : ["紫荆新苑", "天苑花园", "文苑小区", "冠苑小区", "和苑小区"],
        },
        yAxis: {
          type: "value",
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 20,
          },
          {
            start: 0,
            end: 20,
          },
        ],
        series: [
          {
            data: data.length > 0 ? data : [0, 0, 0, 0, 0],
            type: "line",
            stack: "Total",
          },
        ],
      };
      this.chart = this.$echarts.init(this.$refs.myChart);
      this.chart.setOption(options);
    },
    initOptions1(row) {
      let data = [],
        allCont = 0;
      if (row.length > 0) {
        row.forEach((ele) => {
          ele.value = ele.count;
          allCont += ele.count;
        });
        data = row;
      }
      let options = {
        title: {
          text: "各类工单占比图",
          // bottom: "left",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: function (param) {
            var content = "<div>";
            content += "<p>分类名称：" + param.data.name + "</p>";
            content +=
              "<p>工单占比：" +
              ((param.data.value / allCont) * 100).toFixed(2) +
              "%" +
              "</p>";
            content += "</div>";
            return content;
          },
        },
        series: [
          {
            name: "工单占比",
            type: "pie",
            radius: "50%",
            data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.chart1 = this.$echarts.init(this.$refs.myChart1);
      this.chart1.setOption(options);
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 15px;
  border-radius: 5px;
  background: #fff;
  .header {
    width: 100%;
    .title {
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      color: #1a202c;
      text-align: left;
      margin-bottom: 30px;
      position: relative;
    }
    .title::after {
      content: "";
      position: absolute;
      top: 6px;
      left: -8px;
      width: 4px;
      height: 15px;
      background: #5a9cf8;
    }
    .head {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      .left {
        width: 70%;
        height: 300px;
        .summarize,
        .device {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .li {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 14px;
            color: #676779;
            .value {
              font-size: 16px;
              color: #1a202c;
              font-weight: bold;
              margin-bottom: 5px;
              span {
                font-size: 14px;
              }
            }
          }
        }
        .device {
          width: 100%;
          flex-wrap: wrap;
          margin-top: 30px;
          .li {
            width: 15%;
            padding: 15px;
            border-radius: 6px;
            border: 1px solid #dedede;
            box-sizing: border-box;
            margin-bottom: 15px;
            .label {
              width: 100%;
              text-align: left;
              position: relative;
              padding-left: 5px;
            }
            .label::after {
              content: "";
              position: absolute;
              top: 8px;
              left: -8px;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #5a9cf8;
            }
            .value {
              width: 100%;
              text-align: right;
            }
          }
        }
      }
      .right {
        width: 30%;
        .myChart {
          width: 100%;
          height: 300px;
        }
      }
    }
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 0;
    border: 1px solid #dedede;
    border-radius: 10px;
    margin: 50px 0;
    .typeList {
      width: 100%;
      padding: 0 20px;
      .title {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        color: #1a202c;
        text-align: left;
        margin-bottom: 30px;
        position: relative;
      }
      .title::after {
        content: "";
        position: absolute;
        top: 4px;
        left: -8px;
        width: 4px;
        height: 15px;
        background: #5a9cf8;
      }
      .cont {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .li {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-size: 14px;
          color: #676779;
          .value {
            font-size: 16px;
            color: #1a202c;
            font-weight: bold;
            margin-bottom: 5px;
            span {
              font-size: 14px;
            }
          }
        }
      }
    }
    .typeLists {
      border-left: 1px solid #dedede;
      border-right: 1px solid #dedede;
    }
  }
  .footer {
    width: 100%;
    .title {
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      color: #1a202c;
      text-align: left;
      margin-bottom: 30px;
      position: relative;
    }
    .title::after {
      content: "";
      position: absolute;
      top: 6px;
      left: -8px;
      width: 4px;
      height: 15px;
      background: #5a9cf8;
    }
    .foot {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      .left {
        width: 70%;
        height: 300px;
        .statistics {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .li {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 16px;
            color: #676779;
            .value {
              font-size: 14px;
              color: #1a202c;
              font-weight: bold;
              margin-bottom: 5px;
            }
          }
        }
        .orderList {
          width: 100%;
          display: flex;
          align-items: flex-start;
          margin-top: 40px;
          .notice {
            width: 20px;
            margin-right: 30px;
            margin-left: 30px;
          }
          .scroll {
            width: 100%;
            overflow: hidden;
            height: 200px;
          }
          .list {
            width: 100%;
            overflow-y: auto;
            margin-bottom: 10px;
            .li {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 10px;
              transition: all 0.5s;
              cursor: pointer;
              &:last-child {
                margin-bottom: 0;
              }
              &:hover {
                color: #5a9cf8;
              }
              .nottitle {
                width: 500px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }
      }
      .right {
        width: 30%;
        .myChart {
          width: 100%;
          height: 300px;
        }
      }
    }
  }
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
</style>